import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ContactFormComponent } from 'src/app/shared/components/contact-form/contact-form.component';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css'],
    standalone: false
})
export class ContactComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Contacto');
  }

}
